import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from "axios";
import GetCurrentLocation from "../../location/getCurrentLocation";
import { PiCaretUpDownBold, PiMinusBold } from "react-icons/pi";
import { IoFilter, IoCloseOutline } from "react-icons/io5";
import { GrAdd } from "react-icons/gr";
import PropertyBox from '../home/propertyBox';
import { FiGrid } from "react-icons/fi";
import { TbLayoutList } from "react-icons/tb";
import CustomSingleSelectDropdown from '../../widgets/dropdown/CustomSingleSelectDropdown';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { RiFilter2Line } from "react-icons/ri";
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { useSearch } from "../../searchContext/SearchContext";
import { useFilter } from "../../filterContext/filterContext";

import properyImg1 from '../../../assets/images/property/img1.jpg'
import properyImg2 from '../../../assets/images/property/img2.jpg'
import properyImg3 from '../../../assets/images/property/img3.jpg'
import properyImg4 from '../../../assets/images/property/img4.jpg'
import properyImg5 from '../../../assets/images/property/img5.jpg'
import properyImg6 from '../../../assets/images/property/img6.jpg'
import properyImg7 from '../../../assets/images/property/img7.jpg'
import properyImg8 from '../../../assets/images/property/img8.jpg'
import emptyVideo from '../../../assets/images/empty.mp4'


const path = "/keralaplots/";

function Properties() {
    // State to track the selected view mode (grid or list)
    const [district, setDistrict] = useState("");
    const [error, setError] = useState("");
    const [viewMode, setViewMode] = useState("grid");
    const [isShimmerVisible, setIsShimmerVisible] = useState(false);
    const [isFilterActive, setIsFilterActive] = useState(false);
    // State to track the selected sort option
    const [sortOption, setSortOption] = useState("Newest First");
    const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImageLow/";
    const BASE_URL_NOIMG = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.webp";
    // State to track visibility of each filter section
    const [expandedSections, setExpandedSections] = useState({
        purpose: true,
        location: true,
        propertyType: true,
    });
    const { filterData } = useFilter();
    const [properties, setProperties] = useState([]);

    // skelly loader
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true)
    const [townList, setTownList] = useState([]);
    //const [searchQuery, setSearchQuery] = useState("");
    const { searchQuery, setSearchQueryNew } = useSearch();
    const { searchFilter, setSearchFilter } = useFilter();
    //const { searchQuery, setSearchQuery } = useSearch();
    const [filters, setFilters] = useState({
        purpose: filterData.purpose ? [filterData.purpose] : [],
        location: { 
            district: filterData.selectedDistrict || null, 
            town: filterData.selectedTown || null 
        },
        propertyType: filterData.propertyType.length > 0 ? filterData.propertyType : [],
        priceRange: [],
        postedDate: [],
        ownershipType: [],
        readyToMove: [],
    });
    const [showEmptyPage, setShowEmptyPage] = useState(false);

    useEffect(() => {
       //console.log("Received Search Query in Properties:", searchQuery); // Debugging
    }, [searchQuery]);
    useEffect(() => {
        // Fetch properties based on filterData
        //console.log("Filter Data:", filterData);
    }, [filterData]);

  
    useEffect(() => {
        if (searchQuery) {
            //console.log("Search Query:", searchQuery); // Use search query
            setTimeout(() => {
                //setSearchQuery(""); // Remove query after first load
            }, 1000); // Optional delay (1 second)
        }
    }, [searchQuery]);

   
    /**useEffect(() => {
        const isPageReloaded = sessionStorage.getItem('pageReloaded');
        
        // Check if the page is reloaded
        if (isPageReloaded) {
            localStorage.removeItem('searchQuery'); // Remove searchQuery after page reload
            sessionStorage.removeItem('pageReloaded'); // Clear the flag
        } else {
            sessionStorage.setItem('pageReloaded', 'true'); // Set the flag for future reload
        }
    }, []);**/

    useEffect(() => {
        if (filterData.selectedDistrict) {
            fetchTownsByDistrict(filterData.selectedDistrict);
        }
    }, [filterData.selectedDistrict]);
    

    useEffect(() => {
        //('Current Filter Data:', filters);
        fetchPropertyDetails(0); // Reset and fetch data when filters change
    }, [filters,searchQuery]); // Depend on filters change
    
    useEffect(() => {
        if (page !== 0) fetchPropertyDetails(page); // Fetch more data when page changes
    }, [page,filters]); // Depend on page change

    useEffect(() => {
        fetchPropertyDetails(0); // Fetch data when sortOption changes
    }, [sortOption]);

    const fetchPropertyDetails = async (pageNumber = page) => {
        //console.log("hello")
        setIsLoading(true);
        
        //console.log("searchQuery "+searchQuery)
        try {
            const jwtToken = localStorage.getItem('jwtToken');
            const loginId = localStorage.getItem('login_id');
            const districtval = localStorage.getItem('districtval');
            //const searchQuery = localStorage.getIteam('searchQuery');
            //const storedQuery = localStorage.getItem("searchQuery");
            //console.log("searchQuery: ", searchQuery);
    
            if (!jwtToken || !loginId) {
               // console.error("JWT Token or Login ID is missing.");
                //return;
            }
    
            const response = await axios.get(`${baseURL}/allPropertiesList`, {
                params: {
                    purpose: filters.purpose.join(","),
                    district: filters.location.district,
                    town: filters.location.town,
                    propertyType: filters.propertyType.join(","),
                    priceRange: filters.priceRange.join(","),
                    postedDate: filters.postedDate.join(","),
                    ownershipType: filters.ownershipType.join(","),
                    readyToMove: filters.readyToMove.join(","),
                    offset: pageNumber,
                    limit: 24,
                    sortOption: sortOption,
                    searchQuery,
                    loginId,
                    districtval //  Send loginId from localStorage
                }
            });
            //console.log("SQL Query:", response);
    //console.log(response.data)
            if (response.data && response.data.length > 0) {
                setData((prevData) => (pageNumber === 0 ? response.data : [...prevData, ...response.data]));
                setHasMore(response.data.length === 24);
                setShowEmptyPage(false);
            } else {
                setData([]);
                setHasMore(false);
            }
    
            //console.log("Page Number: ", pageNumber);
            //console.log("Response Length: ", response.data.length);
    
            if (pageNumber === 0) {
                setShowEmptyPage(response.data.length === 0);
            }
        } catch (error) {
           // console.error("API Error: ", error);
        }
        
    
        setIsLoading(false);
    };
    

    /**const handleLoadMore = () => {
        if (hasMore) {
            setPage((prevPage) => prevPage + 24);
        }
        //fetchpropertydetails()
    };**/

    const handleLoadMore = () => {
        const nextPage = page + 24;
        setPage(nextPage);
    };
    
    

    const districtList = [
        {
            options: [
                'Trivandrum',
                'Kollam',
                'Alleppey',
                'Pathanamthitta',
                'Kottayam',
                'Idukki',
                'Ernakulam',
                'Thrissur',
                'Palakkad',
                'Malappuram',
                'Kozhikode',
                'Wayanad',
                'Kannur',
                'Kasargod'
            ]
        }
    ];
    

    /**const townList = [
        {
            options: [
                'Town 1',
                'Town 2',
                'Town 3',
                'Town 4',
                'Town 5'
            ]
        }
    ];**/

    // Function to handle view mode change
    const handleViewModeChange = (mode) => {
        setViewMode(mode);
    };

    // State to track filter values
    

    // Function to handle clicking a sort option
    const handleSortOptionClick = (option) => {
        setSortOption(option); // Update the selected sort option
        //fetchPropertyDetails(0);
        setIsOpen(false);
    };

    // Function to toggle a filter section
    const toggleSection = (section) => {
        setExpandedSections((prev) => ({
            ...prev,
            [section]: !prev[section], // Toggle the visibility of the section
        }));
    };

    // Function to handle filter change
    const handleFilterChange = (filterKey, value) => {
        //console.log("filterKey "+filterKey)
        //console.log("value "+value)
        setFilters((prev) => {
            const currentValues = prev[filterKey];
            const updatedFilters = {
                ...prev,
                [filterKey]: currentValues.includes(value)
                    ? currentValues.filter((v) => v !== value)
                    : [...currentValues, value],
            };
    
            setPage(0); // Reset pagination when filters change
            return updatedFilters;
        });
        
    };
    
    

    const handleLocationChange = (type, value) => {
        // Update the filter state for district or town
        setFilters((prev) => ({
            ...prev,
            location: {
                ...prev.location,
                [type]: value, // Set the district or town
            },
        }));
    
        // Check if the type is 'district' and call the API to fetch towns
        if (type === 'district') {
            fetchTownsByDistrict(value);  // Call the function to fetch towns based on the selected district
        }
    };

    // Fetch towns based on the selected district
const fetchTownsByDistrict = (district) => {
    if (!district) return;  // Prevent making API call if district is empty

    // Call the API to fetch towns by district (replace with your actual API endpoint)
    axios.get(`${baseURL}/get-towns/${district}`)
        .then((response) => {
            //console.log(response.data)
            const formattedTownList = [{
                options: response.data.map(town => town.area_name) // Adjust based on actual API response structure
            }];
            setTownList(formattedTownList);  // Set the town list based on API response
            //console.log(townList)
        })
        .catch((error) => {
            //console.error('Error fetching towns:', error);  // Handle error
        });
};

    // Function to clear all filters
    const clearAllFilters = () => {
        setFilters({
            purpose: [],
            location: { district: null, town: null },
            propertyType: [],
            priceRange: [],
            postedDate: [],
            ownershipType: [],
            readyToMove: [],
        });
    };

    // mobileFilterClick
    const mobileFilterClick = () => {
        setIsFilterActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'hidden'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(true);
    };
    const closeMobileFilterClick  = () => {
        setIsFilterActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'inherit'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(false);
    };
    const applyMobileFilterClick  = () => {
        setIsFilterActive((prev) => !prev); // Toggle filter section
        document.body.style.overflow = 'inherit'; // Hide overflow when sidemenu is active
        setIsShimmerVisible(false);
    };


    // sort popup click
    const [isOpen, setIsOpen] = useState(false);
    const sortRef = useRef(null);

    const togglePopup = () => {
        setIsOpen((prev) => !prev);
    };

    // Handle outside click to close popup
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <>
        {/* Fetch user location on page load */}
      <GetCurrentLocation setLocation={setDistrict} setError={setError} />
        <div className="pageLoader">
            <div className="pageLoaderBox"></div>
        </div>

        {isShimmerVisible && (
            <div className="shimmer"></div>
        )}

        <section id="propertyPage">
            <div className="propertyPageHead">
                <div className="propertyPageHeadCol1">
                    <h2>All Properties</h2>
                    <div className="mobileFilterBtn" onClick={mobileFilterClick}><RiFilter2Line /></div>
                </div>
                <div className="propertyPageHeadCol2">
                    <div className="gridBtn">
                        <div
                        className={`gridBtnBox gridViewBtn ${viewMode === "grid" ? "gridBtnBoxActive" : ""}`}
                        onClick={() => handleViewModeChange("grid")}
                        >
                            <FiGrid />
                        </div>
                        {/* Toggle List View */}
                        <div
                            className={`gridBtnBox listViewBtn ${viewMode === "list" ? "gridBtnBoxActive" : ""}`}
                            onClick={() => handleViewModeChange("list")}
                        >
                            <TbLayoutList />
                        </div>
                    </div>
                    <div className="sortBtn" ref={sortRef}>
                        <div className="sortBtnHead" onClick={togglePopup}>
                            <PiCaretUpDownBold />
                            <p>Sort By :</p>
                            <h3>{sortOption}</h3> {/* Display the selected sort option */}
                        </div>
                        <div className={`sortBtnPopup ${isOpen ? "sortBtnPopupActive" : ""}`}>
                            <ul>
                            {/* List items to select sorting options */}
                            {/* <li onClick={() => handleSortOptionClick("Newest First")}>
                                Newest First
                            </li>
                            <li onClick={() => handleSortOptionClick("Price - Low to High")}>
                                Price - Low to High
                            </li>
                            <li onClick={() => handleSortOptionClick("Price - High to Low")}>
                                Price - High to Low
                            </li> */}
                            {["Newest First", "Price - Low to High", "Price - High to Low"].map((option) => (
                                <li
                                    key={option}
                                    className={sortOption === option ? "activeSort" : ""}
                                    onClick={() => handleSortOptionClick(option)}
                                >
                                    {option}
                                </li>
                            ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="propertyPageMain">
                <div className={isFilterActive ? "filterSection filterSectionActive" : "filterSection"}>
                    <div className="filterSectionHead">
                        <div className="filterSectionTitle">
                            <div className="filterSectionTitleCol1">
                                <IoFilter />
                                <h3>Filter</h3>
                            </div>
                            <div className="filterSectionTitleCol2">
                                <div className="clearFilter" onClick={clearAllFilters}>Clear All</div>
                                <div className="closeFilter" onClick={closeMobileFilterClick}>
                                    <IoCloseOutline />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="filterSectionBody">
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Purpose</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('purpose')}>
                                        {expandedSections['purpose'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['purpose'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="sell"
                                                checked={filters.purpose.includes("sell")}
                                                onChange={() => handleFilterChange("purpose", "sell")}
                                            />
                                            <label htmlFor="sell">
                                                <div className="icon"></div>
                                                <p>Buy</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="rent"
                                                checked={filters.purpose.includes("Rent")}
                                                onChange={() => handleFilterChange("purpose", "Rent")}
                                            />
                                            <label htmlFor="rent">
                                                <div className="icon"></div>
                                                <p>Rent</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="lease"
                                                checked={filters.purpose.includes("Lease")}
                                                onChange={() => handleFilterChange("purpose", "Lease")}
                                            />
                                            <label htmlFor="lease">
                                                <div className="icon"></div>
                                                <p>Lease</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Property Type</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('propertyType')}>
                                        {expandedSections['propertyType'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['propertyType'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <h4>All Residential</h4>
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="residentialApartment"
                                                checked={filters.propertyType.includes("Residential Apartment")}
                                                onChange={() => handleFilterChange("propertyType", "Residential Apartment")}
                                            />
                                            <label htmlFor="residentialApartment">
                                                <div className="icon"></div>
                                                <p>Residential Apartment</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="residentialLand"
                                                checked={filters.propertyType.includes("Residential Land")}
                                                onChange={() => handleFilterChange("propertyType", "Residential Land")}
                                            />
                                            <label htmlFor="residentialLand">
                                                <div className="icon"></div>
                                                <p>Residential Land</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="residentialHouseVilla"
                                                checked={filters.propertyType.includes("Residential House/Villa")}
                                                onChange={() => handleFilterChange("propertyType", "Residential House/Villa")}
                                            />
                                            <label htmlFor="residentialHouseVilla">
                                                <div className="icon"></div>
                                                <p>Residential House/Villa</p>
                                            </label>
                                        </li>
                                    </ul>
                                    <h4>All Commercial</h4>
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="commercialShop"
                                                checked={filters.propertyType.includes("Commercial Shop")}
                                                onChange={() => handleFilterChange("propertyType", "Commercial Shop")}
                                            />
                                            <label htmlFor="commercialShop">
                                                <div className="icon"></div>
                                                <p>Commercial Shop</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="commercialOffice"
                                                checked={filters.propertyType.includes("Commercial Office")}
                                                onChange={() => handleFilterChange("propertyType", "Commercial Office")}
                                            />
                                            <label htmlFor="commercialOffice">
                                                <div className="icon"></div>
                                                <p>Commercial Office</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="commercialLand"
                                                checked={filters.propertyType.includes("Commercial Land")}
                                                onChange={() => handleFilterChange("propertyType", "Commercial Land")}
                                            />
                                            <label htmlFor="commercialLand">
                                                <div className="icon"></div>
                                                <p>Commercial Land</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="commercialBuilding"
                                                checked={filters.propertyType.includes("Commercial Building")}
                                                onChange={() => handleFilterChange("propertyType", "Commercial Building")}
                                            />
                                            <label htmlFor="commercialBuilding">
                                                <div className="icon"></div>
                                                <p>Commercial Building</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="commercialOther"
                                                checked={filters.propertyType.includes("Commercial Other")}
                                                onChange={() => handleFilterChange("propertyType", "Commercial Other")}
                                            />
                                            <label htmlFor="commercialOther">
                                                <div className="icon"></div>
                                                <p>Commercial Other</p>
                                            </label>
                                        </li>
                                    </ul>
                                    <h4>All Industrial</h4>
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="industrialBuilding"
                                                checked={filters.propertyType.includes("Industrial Building")}
                                                onChange={() => handleFilterChange("propertyType", "Industrial Building")}
                                            />
                                            <label htmlFor="industrialBuilding">
                                                <div className="icon"></div>
                                                <p>Industrial Building</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="industrialLand"
                                                checked={filters.propertyType.includes("Industrial Land")}
                                                onChange={() => handleFilterChange("propertyType", "Industrial Land")}
                                            />
                                            <label htmlFor="industrialLand">
                                                <div className="icon"></div>
                                                <p>Industrial Land</p>
                                            </label>
                                        </li>
                                    </ul>
                                    <h4>All Agricultural</h4>
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="agriculturalLand"
                                                checked={filters.propertyType.includes("Agricultural Land")}
                                                onChange={() => handleFilterChange("propertyType", "Agricultural Land")}
                                            />
                                            <label htmlFor="agriculturalLand">
                                                <div className="icon"></div>
                                                <p>Agricultural Land</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Location</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('location')}>
                                        {expandedSections['location'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['location'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <h4>District</h4>
                                    <div className="formGroup">
                                        <CustomSingleSelectDropdown
                                            options={districtList}
                                            label="District"
                                            value={filters.location.district} // Bind to state
                                            onChange={(value) => handleLocationChange('district', value)} // Update state on change
                                        />
                                    </div>
                                    <h4>Town</h4>
                                    <div className="formGroup">
                                    <CustomSingleSelectDropdown
                    options={Array.isArray(townList) ? townList : []} // Ensure array
                    label="Town"
                    value={filters.location.town} // Ensure it doesn't break
                    onChange={(value) => handleLocationChange('town', value)}
                    searchable={true}
                />
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Price Range</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('priceRange')}>
                                        {expandedSections['priceRange'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['priceRange'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange1"
                                                checked={filters.priceRange.includes("1000 to 5000")}
                                                onChange={() => handleFilterChange("priceRange", "1000 to 5000")}
                                            />
                                            <label htmlFor="priceRange1">
                                                <div className="icon"></div>
                                                <p>1,000 to 5,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange2"
                                                checked={filters.priceRange.includes("5000 to 10000")}
                                                onChange={() => handleFilterChange("priceRange", "5000 to 10000")}
                                            />
                                            <label htmlFor="priceRange2">
                                                <div className="icon"></div>
                                                <p>5,000 to 10,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange3"
                                                checked={filters.priceRange.includes("10000 to 15000")}
                                                onChange={() => handleFilterChange("priceRange", "10000 to 15000")}
                                            />
                                            <label htmlFor="priceRange3">
                                                <div className="icon"></div>
                                                <p>10,000 to 15,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange4"
                                                checked={filters.priceRange.includes("15000 to 20000")}
                                                onChange={() => handleFilterChange("priceRange", "15000 to 20000")}
                                            />
                                            <label htmlFor="priceRange4">
                                                <div className="icon"></div>
                                                <p>15,000 to 20,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange5"
                                                checked={filters.priceRange.includes("20000 to 25000")}
                                                onChange={() => handleFilterChange("priceRange", "20000 to 25000")}
                                            />
                                            <label htmlFor="priceRange5">
                                                <div className="icon"></div>
                                                <p>20,000 to 25,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange6"
                                                checked={filters.priceRange.includes("25000 to 30000")}
                                                onChange={() => handleFilterChange("priceRange", "25000 to 30000")}
                                            />
                                            <label htmlFor="priceRange6">
                                                <div className="icon"></div>
                                                <p>25,000 to 30,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange7"
                                                checked={filters.priceRange.includes("30000 to 35000")}
                                                onChange={() => handleFilterChange("priceRange", "30000 to 35000")}
                                            />
                                            <label htmlFor="priceRange7">
                                                <div className="icon"></div>
                                                <p>30,000 to 35,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange8"
                                                checked={filters.priceRange.includes("35000 to 40000")}
                                                onChange={() => handleFilterChange("priceRange", "35000 to 40000")}
                                            />
                                            <label htmlFor="priceRange8">
                                                <div className="icon"></div>
                                                <p>35,000 to 40,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange9"
                                                checked={filters.priceRange.includes("40000 to 45000")}
                                                onChange={() => handleFilterChange("priceRange", "40000 to 45000")}
                                            />
                                            <label htmlFor="priceRange9">
                                                <div className="icon"></div>
                                                <p>40,000 to 45,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange10"
                                                checked={filters.priceRange.includes("45000 to 50000")}
                                                onChange={() => handleFilterChange("priceRange", "45000 to 50000")}
                                            />
                                            <label htmlFor="priceRange10">
                                                <div className="icon"></div>
                                                <p>45,000 to 50,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange11"
                                                checked={filters.priceRange.includes("50000 to 55000")}
                                                onChange={() => handleFilterChange("priceRange", "50000 to 55000")}
                                            />
                                            <label htmlFor="priceRange11">
                                                <div className="icon"></div>
                                                <p>50,000 to 55,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange12"
                                                checked={filters.priceRange.includes("55000 to 60000")}
                                                onChange={() => handleFilterChange("priceRange", "55000 to 60000")}
                                            />
                                            <label htmlFor="priceRange12">
                                                <div className="icon"></div>
                                                <p>55,000 to 60,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange13"
                                                checked={filters.priceRange.includes("60000 to 65000")}
                                                onChange={() => handleFilterChange("priceRange", "60000 to 65000")}
                                            />
                                            <label htmlFor="priceRange13">
                                                <div className="icon"></div>
                                                <p>60,000 to 65,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange14"
                                                checked={filters.priceRange.includes("65000 to 70000")}
                                                onChange={() => handleFilterChange("priceRange", "65000 to 70000")}
                                            />
                                            <label htmlFor="priceRange14">
                                                <div className="icon"></div>
                                                <p>65,000 to 70,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange15"
                                                checked={filters.priceRange.includes("70000 to 75000")}
                                                onChange={() => handleFilterChange("priceRange", "70000 to 75000")}
                                            />
                                            <label htmlFor="priceRange15">
                                                <div className="icon"></div>
                                                <p>70,000 to 75,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange16"
                                                checked={filters.priceRange.includes("75000 to 80000")}
                                                onChange={() => handleFilterChange("priceRange", "75000 to 80000")}
                                            />
                                            <label htmlFor="priceRange16">
                                                <div className="icon"></div>
                                                <p>75,000 to 80,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange17"
                                                checked={filters.priceRange.includes("80000 to 85000")}
                                                onChange={() => handleFilterChange("priceRange", "80000 to 85000")}
                                            />
                                            <label htmlFor="priceRange17">
                                                <div className="icon"></div>
                                                <p>80,000 to 85,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange18"
                                                checked={filters.priceRange.includes("85000 to 90000")}
                                                onChange={() => handleFilterChange("priceRange", "85000 to 90000")}
                                            />
                                            <label htmlFor="priceRange18">
                                                <div className="icon"></div>
                                                <p>85,000 to 90,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange19"
                                                checked={filters.priceRange.includes("90000 to 100000")}
                                                onChange={() => handleFilterChange("priceRange", "90000 to 100000")}
                                            />
                                            <label htmlFor="priceRange19">
                                                <div className="icon"></div>
                                                <p>90,000 to 1,00,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange20"
                                                checked={filters.priceRange.includes("100000 to 500000")}
                                                onChange={() => handleFilterChange("priceRange", "100000 to 500000")}
                                            />
                                            <label htmlFor="priceRange20">
                                                <div className="icon"></div>
                                                <p>1,00,000 to 5,00,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange21"
                                                checked={filters.priceRange.includes("500000 to 1000000")}
                                                onChange={() => handleFilterChange("priceRange", "500000 to 1000000")}
                                            />
                                            <label htmlFor="priceRange21">
                                                <div className="icon"></div>
                                                <p>5,00,000 to 10,00,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange22"
                                                checked={filters.priceRange.includes("1000000 to 5000000")}
                                                onChange={() => handleFilterChange("priceRange", "1000000 to 5000000")}
                                            />
                                            <label htmlFor="priceRange22">
                                                <div className="icon"></div>
                                                <p>10,00,000 to 50,00,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange23"
                                                checked={filters.priceRange.includes("5000000 to 10000000")}
                                                onChange={() => handleFilterChange("priceRange", "5000000 to 10000000")}
                                            />
                                            <label htmlFor="priceRange23">
                                                <div className="icon"></div>
                                                <p>50,00,000 to 1,00,00,000</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="priceRange24"
                                                checked={filters.priceRange.includes("10000000 to 100000000")}
                                                onChange={() => handleFilterChange("priceRange", "10000000 to 100000000")}
                                            />
                                            <label htmlFor="priceRange24">
                                                <div className="icon"></div>
                                                <p>Above 1,00,00,000</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Posted Date</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('postedDate')}>
                                        {expandedSections['postedDate'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['postedDate'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="today"
                                                checked={filters.postedDate.includes("Today")}
                                                onChange={() => handleFilterChange("postedDate", "Today")}
                                            />
                                            <label htmlFor="today">
                                                <div className="icon"></div>
                                                <p>Today</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="thisWeek"
                                                checked={filters.postedDate.includes("This Week")}
                                                onChange={() => handleFilterChange("postedDate", "This Week")}
                                            />
                                            <label htmlFor="thisWeek">
                                                <div className="icon"></div>
                                                <p>This Week</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="thisMonth"
                                                checked={filters.postedDate.includes("This Month")}
                                                onChange={() => handleFilterChange("postedDate", "This Month")}
                                            />
                                            <label htmlFor="thisMonth">
                                                <div className="icon"></div>
                                                <p>This Month</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="last3Month"
                                                checked={filters.postedDate.includes("Last 3 Month")}
                                                onChange={() => handleFilterChange("postedDate", "Last 3 Month")}
                                            />
                                            <label htmlFor="last3Month">
                                                <div className="icon"></div>
                                                <p>Last 3 Month</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="last6Month"
                                                checked={filters.postedDate.includes("Last 6 Month")}
                                                onChange={() => handleFilterChange("postedDate", "Last 6 Month")}
                                            />
                                            <label htmlFor="last6Month">
                                                <div className="icon"></div>
                                                <p>Last 6 Month</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Ownership Type</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('ownershipType')}>
                                        {expandedSections['ownershipType'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['ownershipType'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="single"
                                                checked={filters.ownershipType.includes("Single")}
                                                onChange={() => handleFilterChange("ownershipType", "Single")}
                                            />
                                            <label htmlFor="single">
                                                <div className="icon"></div>
                                                <p>Single</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="Joint"
                                                checked={filters.ownershipType.includes("Joint")}
                                                onChange={() => handleFilterChange("ownershipType", "Joint")}
                                            />
                                            <label htmlFor="Joint">
                                                <div className="icon"></div>
                                                <p>Joint</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="Trust"
                                                checked={filters.ownershipType.includes("Trust")}
                                                onChange={() => handleFilterChange("ownershipType", "Trust")}
                                            />
                                            <label htmlFor="Trust">
                                                <div className="icon"></div>
                                                <p>Trust</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="Others"
                                                checked={filters.ownershipType.includes("Others")}
                                                onChange={() => handleFilterChange("ownershipType", "Others")}
                                            />
                                            <label htmlFor="Others">
                                                <div className="icon"></div>
                                                <p>Others</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/*<div className="filterSectionBox">
                            <div className="filterSectionBoxHead">
                                <div className="filterSectionBoxHeadCol1">
                                    <h3>Ready to Move</h3>
                                </div>
                                <div className="filterSectionBoxHeadCol2">
                                    <div className="expandFilterBtn" onClick={() => toggleSection('readyToMove')}>
                                        {expandedSections['readyToMove'] ? <PiMinusBold /> : <GrAdd />}
                                    </div>
                                </div>
                            </div>
                            <div
                                className="filterSectionBoxBody"
                                style={{ display: expandedSections['readyToMove'] ? 'flex' : 'none' }}
                            >
                                <div className="filterSectionBoxList">
                                    <ul>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="readyToMoveYes"
                                                checked={filters.readyToMove.includes("Yes")}
                                                onChange={() => handleFilterChange("readyToMove", "Yes")}
                                            />
                                            <label htmlFor="readyToMoveYes">
                                                <div className="icon"></div>
                                                <p>Yes</p>
                                            </label>
                                        </li>
                                        <li>
                                            <input
                                                type="checkbox"
                                                id="readyToMoveNo"
                                                checked={filters.readyToMove.includes("No")}
                                                onChange={() => handleFilterChange("readyToMove", "No")}
                                            />
                                            <label htmlFor="readyToMoveNo">
                                                <div className="icon"></div>
                                                <p>No</p>
                                            </label>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>*/}
                    </div>
                    <div className="filterSectionBoxFooter">
                        <div className="clearFilter" onClick={clearAllFilters}>Clear Filter</div>
                        <div className="applyFilter" onClick={applyMobileFilterClick}>Apply Filter</div>
                    </div>
                </div>
                <div className="propertyPageList">
                <div className={`propertyPageListMain ${viewMode === "list" ? "listView" : ""}`}>
                    {isLoading && data.length === 0 ? (
                        <div className="SkeletonLoader">
                            {[...Array(6)].map((_, index) => (
                                <div key={index} className="SkeletonLoaderBox">
                                    <div className="SkeletonLoaderBoxCol1">
                                        <Skeleton />
                                    </div>
                                    <div className="SkeletonLoaderBoxCol2">
                                        <Skeleton />
                                        <Skeleton />
                                        <Skeleton />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        
                            data.map((allPropertie) => {
                               // console.log(filters)
                                //console.log(allPropertie.propertyId)
                               //console.log(allPropertie)
                                return (
                                    <PropertyBox 
                                    key={allPropertie.propertyId}
                                    propertyLink={`${path}innerProperty/${allPropertie.propertyId}/${allPropertie.propertyType.replace('/', '').replace(/\s+/g, '-')}-for-${allPropertie.propertyAction === 'sell' ? 'sale' : allPropertie.propertyAction}`}
                                    propertyImage={allPropertie.imageName ? "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImageLow/"+allPropertie.imageName : BASE_URL_NOIMG} 
                                    propertyPurposeTag={allPropertie.propertyAction} 
                                    propertyId={allPropertie.propertyId}
                                    propertyName={`${allPropertie.propertyType} For ${allPropertie.propertyAction === 'sell' ? 'sale' : allPropertie.propertyAction}`} 
                                    propertyLocation={allPropertie.district +' , '+ allPropertie.town}
                                    propertyDate={allPropertie.addedDate}
                                    propertyPrice={allPropertie.priceVisibility === 'No' ? 'Not disclosed' : allPropertie.propertyPricerange} 
                                    propertyType={allPropertie.propertyType}
                                    propertySeen={false}
                                    propertyContacted={false}
                                    savedStatus={allPropertie.savedStatus} // Pass the savedStatus
                                    addedId={allPropertie.loginId}
                                />
                                )
                            })
                            
                        )}
                        </div>
                        {hasMore && (
                    <div className="loadMoreArea">
                        <button
                            className="loadMoreBtn"
                            onClick={handleLoadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? "Loading..." : "Load More"}
                        </button>
                        
                    </div>
                        )}
                      
                        <div className="emptyPage" style={{ display: showEmptyPage ? "flex" : "none" }}>
                            <div className="container">
                                <div className="emptyPageMain">
                                <div className="emptyPageBoxThumbnail">
                                    <video
                                        playsInline
                                        preload="auto"
                                        autoPlay
                                        muted
                                        loop
                                    >
                                        <source src={emptyVideo} type="video/mp4" />
                                    </video>
                                </div>
                                <div className="emptyPageBoxDetails">
                                    <h2 className="title">No matches found!</h2>
                                    <p>Your perfect place is out there! 🏡"
                                    Try adjusting your filters or expanding your search to discover more options.!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
}

export default Properties;
